import dayjs from 'dayjs';
import utc from 'dayjs/plugin/utc';
import timezone from 'dayjs/plugin/timezone';

dayjs.extend(utc);
dayjs.extend(timezone);

export function convertUTCtoIST(utcDateStr) {
    if (!utcDateStr) return null;
    return dayjs.utc(utcDateStr).tz('Asia/Kolkata').format('DD-MM-YYYY hh:mm A');
}


export const formatDateTime = (date) => {
    return new Date(date).toISOString().slice(0, 19);
};


// reactSelectStyles.js
export const customStyles = {
    menu: (provided) => ({
        ...provided,
        zIndex: 9999,
    }),
};
